import React from "react"

const PIP_POSITIONS = {
    1: [5],
    2: [3, 7],
    3: [3, 5, 7],
    4: [1, 3, 7, 9],
    5: [1, 3, 5, 7, 9],
    6: [1, 3, 4, 6, 7, 9],
}

function Pips({ value }) {
    const positions = PIP_POSITIONS[value || 1] || []
    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', width: '34px', height: '34px' }}>
            {Array.from({ length: 9 }, (_, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {positions.includes(i + 1) && (
                        <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: 'currentColor' }} />
                    )}
                </div>
            ))}
        </div>
    )
}

export default function Die(props) {
    const bgClass = props.isRed
        ? (props.isHeld ? 'bg-red-500 text-white ring-[3px] ring-bankroll-primary' : 'bg-red-500 text-white')
        : (props.isHeld ? 'bg-white text-bankroll-text ring-[3px] ring-bankroll-primary' : 'bg-white text-bankroll-text')

    return (
        <div
            className={`h-[50px] w-[50px] shadow-sm rounded-[10px] flex justify-center items-center cursor-pointer ${bgClass}${props.isRolling ? ' die-rolling' : ''}`}
            onClick={props.holdDice}
        >
            <Pips value={props.value} />
        </div>
    )
}
